var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessengerPana(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.51,463.69c-26.15-10.36-38.15-38.25-43.46-64.61-.89-4.4-2.46-8.89-1.29-13.21s5.39-8.09,9.73-7.18c3.61.76,5.92,4.19,8.47,6.88a26.23,26.23,0,0,0,12.56,7.35c3.12.79,6.77.85,9.15-1.31,3.28-3,2.49-8.28,1.43-12.62l-5.91-24.24c-1.06-4.33-2.12-8.76-1.75-13.21s2.45-9,6.31-11.11,9.52-1,11.4,3.08c.79,1.68.86,3.6,1.41,5.37s1.86,3.57,3.69,3.67,3.3-1.55,4.3-3.13c3.44-5.44,5.14-11.81,6.65-18.1s2.91-12.7,5.84-18.44,7.66-10.87,13.79-12.7,13.67.44,16.69,6.17.93,12.81-1.78,18.68a99.64,99.64,0,0,1-15.62,24c-1.13,1.29-2.37,2.69-2.51,4.43-.26,3.11,3.17,5.34,6.25,5.61,3.49.31,6.93-.86,10.41-1.26s7.5.22,9.54,3.11c2.83,4,.22,9.55-2.71,13.46a85.17,85.17,0,0,1-21.21,20c-2.91,1.92-6,3.75-8.08,6.6s-2.67,7.13-.39,9.82,6.51,2.72,9.71,1.31,5.76-3.94,8.67-5.9c5.43-3.67,13.23-5.09,18.28-.84,3.31,2.8,4.66,7.46,4.34,11.81s-2.06,8.43-4,12.29C460.48,433,450.38,445,437.68,453s-25.22,12.42-40.17,10.66",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.37,445.69a399.69,399.69,0,0,1,5.51-45.55q1-6,2.06-11.87c.68-3.89,1.36-7.75,2.26-11.49a198.85,198.85,0,0,1,6.38-21.17c2.35-6.63,4.83-12.84,7.19-18.63s4.68-11.14,7-15.93a157.44,157.44,0,0,1,12.6-21.76c1.68-2.44,3.05-4.3,4-5.54q.69-.88,1.08-1.41a2.62,2.62,0,0,1,.4-.46,3.7,3.7,0,0,1-.33.52l-1,1.45c-.9,1.28-2.23,3.16-3.87,5.62a169.12,169.12,0,0,0-12.34,21.84c-2.27,4.79-4.55,10.14-6.89,15.93s-4.78,12-7.11,18.64A201.91,201.91,0,0,0,411,377c-.89,3.72-1.56,7.55-2.24,11.45s-1.36,7.86-2.05,11.86a406.73,406.73,0,0,0-5.56,45.45",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.42,376.7a8.66,8.66,0,0,1-.87-1.76c-.51-1.14-1.2-2.82-2-4.91-1.64-4.18-3.71-10-6-16.48s-4.4-12.26-6.09-16.4c-.85-2.07-1.55-3.74-2.05-4.89a8.25,8.25,0,0,1-.68-1.83,9,9,0,0,1,1,1.69c.59,1.11,1.37,2.75,2.29,4.8,1.84,4.1,4.08,9.89,6.34,16.35s4.2,12.15,5.73,16.55l1.77,5A9.47,9.47,0,0,1,410.42,376.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.77,353a11.92,11.92,0,0,1-2.17.8c-1.4.46-3.43,1.13-5.92,2-5,1.76-11.77,4.44-19.14,7.73s-13.91,6.56-18.57,9.06c-2.34,1.24-4.21,2.29-5.5,3a13,13,0,0,1-2.05,1.06,12.06,12.06,0,0,1,1.88-1.33c1.25-.81,3.08-1.94,5.39-3.24,4.6-2.64,11.12-6,18.51-9.31a200.92,200.92,0,0,1,19.3-7.53c2.51-.83,4.58-1.41,6-1.78A11.54,11.54,0,0,1,463.77,353Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.81,444.5a3.41,3.41,0,0,1-.54-.59l-1.43-1.79c-1.24-1.57-3-3.88-5.08-6.75-4.21-5.76-9.77-13.9-15.79-22.95s-11.51-17.24-15.59-23.08l-4.86-6.9c-.53-.75-1-1.37-1.31-1.88s-.44-.67-.41-.69.2.18.54.59l1.43,1.79c1.24,1.56,3,3.87,5.08,6.75,4.21,5.76,9.77,13.89,15.8,22.95s11.5,17.24,15.58,23.07l4.86,6.9,1.31,1.89C400.69,444.24,400.84,444.48,400.81,444.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.33,403a3.11,3.11,0,0,1-.67.48l-2,1.23-7.33,4.46c-6.2,3.77-14.69,9.07-24.06,14.94s-17.93,11.1-24.2,14.74c-3.13,1.82-5.69,3.26-7.47,4.23l-2.06,1.1a3.08,3.08,0,0,1-.75.33,3.11,3.11,0,0,1,.67-.48l2-1.23,7.33-4.46c6.2-3.77,14.69-9.07,24.07-14.94s17.92-11.09,24.19-14.73c3.13-1.82,5.68-3.27,7.47-4.24l2.06-1.09A2.93,2.93,0,0,1,469.33,403Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.41,
    y: 151.47,
    width: 70.07,
    height: 103.96,
    transform: "translate(-114.37 268.17) rotate(-79.01)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.32,179.85a6.51,6.51,0,0,1-1.13.73l-3.32,1.94-12.33,7-40.93,22.78-.33.18-.25-.29-.61-.71L73.76,175.22l-9.21-11.05-2.47-3a6.57,6.57,0,0,1-.81-1.1,8.32,8.32,0,0,1,.95,1l2.61,2.92,9.44,10.86,30.87,36.06.61.71-.59-.11,41.06-22.53,12.47-6.72,3.41-1.78A7.24,7.24,0,0,1,163.32,179.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.91,228.82c-.17-.21,9.34-8.14,21.23-17.73s21.66-17.2,21.82-17-9.34,8.14-21.23,17.73S48.07,229,47.91,228.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.05,199.82c.23-.12,6,10.72,12.87,24.19s12.27,24.51,12,24.63-6-10.71-12.88-24.2S124.82,199.94,125.05,199.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.29 145.35 139.78 152.1 134.47 107.28 198.98 100.52 204.29 145.35",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.25,101a3.8,3.8,0,0,1-.53.66l-1.6,1.81-6,6.59-19.95,21.62-.16.18-.21-.14-.5-.32c-9.82-6.48-18.72-12.33-25.22-16.61l-7.61-5.1-2-1.41a4.42,4.42,0,0,1-.69-.52,4.6,4.6,0,0,1,.75.42l2.11,1.32c1.88,1.19,4.5,2.87,7.71,4.93l25.31,16.46.5.32-.37,0c7.84-8.38,14.91-16,20.08-21.49l6.12-6.45c.7-.72,1.26-1.3,1.69-1.73A5.05,5.05,0,0,1,199.25,101Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.05,152.62c-.14-.09,4-6.75,9.21-14.86s9.56-14.61,9.7-14.51-4,6.74-9.21,14.86S140.18,152.71,140.05,152.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.34,120.44c.12-.11,5.63,5.48,12.32,12.5s12,12.81,11.9,12.92-5.63-5.48-12.32-12.5S180.22,120.56,180.34,120.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.9 91.02 79.25 66.33 96.09 41.3 131.74 65.98 114.9 91.02",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.65,66.36a2.59,2.59,0,0,1-.56.11l-1.6.22-5.9.73-19.54,2.26-.16,0,0-.15c0-.13-.07-.26-.11-.39L98.18,49.75c-.68-2.46-1.24-4.46-1.63-5.9l-.43-1.6a2.73,2.73,0,0,1-.12-.57,3.27,3.27,0,0,1,.2.54c.12.4.29.93.49,1.59.43,1.42,1,3.41,1.76,5.85,1.46,5,3.46,11.83,5.66,19.38l.11.38-.2-.14,19.54-2.15,5.92-.6,1.61-.14A3.92,3.92,0,0,1,131.65,66.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.16,66.71c0-.1,5-1.68,11.14-3.51s11.22-3.24,11.25-3.14-5,1.69-11.15,3.52S79.19,66.82,79.16,66.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.61,68c.11,0,.46,5.23.8,11.7s.51,11.73.4,11.74-.47-5.23-.8-11.7S113.5,68,113.61,68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.46,123.87a39.75,39.75,0,1,0-74,20.08h0l.11.15c1.52,2.57,3.43,4.41,5.36,7.11L356,181.78a7.19,7.19,0,0,0,11.46,0l22.7-30.07a86.09,86.09,0,0,0,5.77-7.65L396,144h0A39.56,39.56,0,0,0,401.46,123.87Zm-39.75,17.31a17.5,17.5,0,1,1,17.5-17.5A17.5,17.5,0,0,1,361.71,141.18Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.86,192.09A21.44,21.44,0,1,0,392,202.92h0l.06.08c.82,1.38,1.85,2.38,2.89,3.83l12.45,16.49a3.86,3.86,0,0,0,6.17,0l12.24-16.22a45.88,45.88,0,0,0,3.12-4.12l0-.06h0A21.28,21.28,0,0,0,431.86,192.09Zm-21.44,9.33a9.43,9.43,0,1,1,9.44-9.43A9.43,9.43,0,0,1,410.42,201.42Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.37,463.77c0,.15-99.12.26-221.36.26s-221.38-.11-221.38-.26,99.1-.26,221.38-.26S471.37,463.63,471.37,463.77Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.35,118.94l6.58,93.2a29.06,29.06,0,0,0,29,27h0a29.06,29.06,0,0,0,29-31c-.58-8.87-1.11-16.13-1.11-16.13s22.57-3.51,22.85-26.07c.16-13-2.09-42.6-4-65.25a29.59,29.59,0,0,0-29.49-27.07H228.51A41.75,41.75,0,0,0,189.35,118.94Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.84,191.73s-14.26,1.16-29.41-8.36c0,0,6.95,16.24,29.46,14.21Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.62,128a3.22,3.22,0,0,1-3.11,3.25,3.08,3.08,0,0,1-3.32-2.9,3.23,3.23,0,0,1,3.1-3.26A3.09,3.09,0,0,1,264.62,128Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.74,123.36c-.4.42-2.84-1.38-6.3-1.37s-6,1.74-6.39,1.32c-.18-.19.23-1,1.33-1.76a8.85,8.85,0,0,1,5.11-1.57,8.42,8.42,0,0,1,5,1.62C267.58,122.42,267.94,123.18,267.74,123.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.79,128a3.22,3.22,0,0,1-3.11,3.25,3.08,3.08,0,0,1-3.32-2.9,3.23,3.23,0,0,1,3.11-3.26A3.09,3.09,0,0,1,230.79,128Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.67,124c-.4.42-2.85-1.39-6.31-1.38s-6,1.75-6.39,1.32c-.18-.19.22-.94,1.33-1.75a9,9,0,0,1,5.11-1.58,8.62,8.62,0,0,1,5,1.62C233.5,123.06,233.86,123.82,233.67,124Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.25,149.72c0-.2,2.14-.57,5.63-1,.88-.1,1.72-.27,1.87-.88a4.47,4.47,0,0,0-.59-2.62q-1.24-3.21-2.62-6.74c-3.63-9.6-6.27-17.49-5.88-17.63s3.65,7.52,7.29,17.11q1.31,3.56,2.51,6.79c.33,1,.91,2.14.45,3.47a2.18,2.18,0,0,1-1.45,1.29,5.49,5.49,0,0,1-1.5.21C248.44,149.9,246.26,149.92,246.25,149.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.05,152.12c.56,0,.57,3.73,3.79,6.4s7.22,2.26,7.25,2.78c.06.24-.89.73-2.58.78a9.38,9.38,0,0,1-6.06-2.11,8.15,8.15,0,0,1-2.94-5.37C235.37,153,235.79,152.1,236.05,152.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.56,110.42c-.34,1-3.8.5-7.87,1s-7.36,1.6-7.9.75c-.24-.4.33-1.29,1.66-2.2a13.79,13.79,0,0,1,12-1.33C234,109.24,234.71,110,234.56,110.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.47,113.33c-.61.79-3,0-5.87-.07s-5.3.53-5.86-.29c-.25-.4.13-1.19,1.2-1.94a8.48,8.48,0,0,1,9.45.3C266.4,112.13,266.74,113,266.47,113.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,135.87c-.39-.17-15.5-4.58-15,10.84s15.87,11.75,15.89,11.3S197,135.87,197,135.87Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.94,152.32c-.07,0-.26.2-.71.42a2.71,2.71,0,0,1-2,.11c-1.65-.55-3.1-3.09-3.27-5.87a9,9,0,0,1,.63-3.87,3.12,3.12,0,0,1,2-2.13,1.37,1.37,0,0,1,1.61.69c.22.42.13.73.21.76s.33-.27.18-.91a1.7,1.7,0,0,0-.64-.94,2,2,0,0,0-1.5-.35,3.79,3.79,0,0,0-2.73,2.48,9.24,9.24,0,0,0-.79,4.33c.2,3.11,1.88,6,4.13,6.54a2.88,2.88,0,0,0,2.45-.49C192.92,152.7,193,152.35,192.94,152.32Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.38,135.35c2.35-.57,6.42,1.6,7.42,3.8s1.22,4.7,2.22,6.91,3.26,4.19,5.62,3.63a4.73,4.73,0,0,0,3.21-3.51,13,13,0,0,0,.05-5c-.91-7.2-2.42-14.34-2.71-21.6s.74-14.79,4.55-21,10.8-10.73,18-10.14c4.79.38,9.19,2.88,13.95,3.55a18.83,18.83,0,0,0,15.66-5.23c.52-.51,2.92-2.1,2.92-2.1,0-.37-.35-3.59-1.62-4.77-9.45-8.73-26.47-11.17-38.95-8s-24.18,12-29.55,23.64-3.77,28-.81,39.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.88,97.26s-59.18-19-84.78,32.16c0,0-3.83-12.81-3.83-19.68,0-4.59,2.74-31.91,30.86-40.51C214.13,69.23,256.48,53.07,271.88,97.26Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,98.54a12.88,12.88,0,0,0,20.49,1.86,7.59,7.59,0,0,0,14.35-.75,17.14,17.14,0,0,0,5.76,4.2c2.25.83,5.1.51,6.57-1.37s1.07-4.85-.41-6.79a14,14,0,0,0-6-4,43.27,43.27,0,0,0-22.34-3.38c-7.55,1-14.86,4.68-19.58,10.66",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M271.88,97.26a27.51,27.51,0,0,0-18.82-8.55c-17.46-.77-50.13,9.05-66,40.71,0,0-3.83-12.81-3.83-19.68,0-4.59,2.74-31.91,30.86-40.51C214.13,69.23,256.48,53.07,271.88,97.26Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M189.57,123.43c8.77-13.43,20.87-24.53,34.48-33s36.1-16.9,51.6-21c4.66-1.24,9.51-2.32,14.26-1.5s9.39,4,10.56,8.65c1.48,5.85-8.9,14.87-13.77,18.41s-14.82,8.75-14.82,8.75.14-10.84-17.22-13.07C231.06,87.58,189.57,123.43,189.57,123.43Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.11,79.2s8.52-4.72,17.09-5.82a22.28,22.28,0,0,0-4.65-2.78,43.93,43.93,0,0,0-13.32,4.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.14,211.46l-18.77-4.14-7.64-1.91-6.36-9.86s-3,17.63-14.39,27.12a13.21,13.21,0,0,1-11.19,2.68c-2.57-.54-5.59-1.2-7.83-1.8-.48-.13-1-.3-1.56-.5a36.61,36.61,0,0,1-19.33-16.67c-2.52-4.48-4.65-9.08-3.92-10.83L186.24,214l-52.5,24.18L103.93,311l57.77,17.08,1.8,60-10.88,75.64,163.43.11-5.8-168.29",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.89,276.61a6.29,6.29,0,0,1-1,0l-2.91-.07-10.39-.37h-.2V276c-.17-4.51-.38-9.85-.61-15.56-.27-8.23-.51-15.67-.7-21.14-.06-2.66-.11-4.83-.15-6.41,0-.71,0-1.29,0-1.74a2.4,2.4,0,0,1,0-.61,2.66,2.66,0,0,1,.07.6c0,.46.07,1,.11,1.74.08,1.58.19,3.75.32,6.4.22,5.47.52,12.91.85,21.13.2,5.72.38,11.06.54,15.57l-.22-.21,10.39.55,2.9.19A4.61,4.61,0,0,1,243.89,276.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,252.3a1.44,1.44,0,0,1,.78-.26,3.37,3.37,0,0,1,3.2,1.79,3,3,0,0,1,.29,1.82,3.68,3.68,0,0,1-2.67,3,3.87,3.87,0,0,1-3.8-1.35,3.69,3.69,0,0,1-.72-3.23,3.93,3.93,0,0,1,1.08-2c.38-.37.66-.49.67-.46s-.2.21-.52.6a4.22,4.22,0,0,0-.87,1.89,3.39,3.39,0,0,0,.72,2.85,3.47,3.47,0,0,0,3.32,1.16,3.23,3.23,0,0,0,2.31-2.58,2.72,2.72,0,0,0-1.07-2.64,3.16,3.16,0,0,0-1.93-.69C235.27,252.24,235,252.34,235,252.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.23,231.17a1.6,1.6,0,0,1,.82-.38,3.55,3.55,0,0,1,2.44.36,3.49,3.49,0,0,1,1.31,1.16,3.28,3.28,0,0,1,.55,1.95,3.92,3.92,0,0,1-2.64,3.55,4,4,0,0,1-4.18-1.46,3.51,3.51,0,0,1-.73-1.88,4.14,4.14,0,0,1,.28-1.73,4,4,0,0,1,1.57-1.9,1.63,1.63,0,0,1,.85-.32s-.29.15-.73.49a4,4,0,0,0-1.34,1.86,3.29,3.29,0,0,0,.48,3.19,3.54,3.54,0,0,0,3.65,1.25,3.48,3.48,0,0,0,2.31-3.07,3,3,0,0,0-1.55-2.77,3.62,3.62,0,0,0-2.23-.48C233.54,231.06,233.25,231.21,233.23,231.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.91,311.88s.08-.05.25-.11l.75-.29c.67-.23,1.62-.65,2.83-1.21a37.52,37.52,0,0,0,9.2-6.54,73.42,73.42,0,0,0,10.53-13.06,184.28,184.28,0,0,0,10.26-17.88,311.34,311.34,0,0,0,14.57-34.52c1.63-4.52,2.9-8.19,3.79-10.72l1-2.92c.11-.3.21-.55.28-.75a1.39,1.39,0,0,1,.11-.25,1,1,0,0,1-.06.27c-.06.2-.14.45-.23.77-.23.71-.54,1.69-.93,3-.83,2.55-2.05,6.24-3.65,10.77A287.93,287.93,0,0,1,262.19,273a178.54,178.54,0,0,1-10.32,17.91A72.1,72.1,0,0,1,241.19,304a36.37,36.37,0,0,1-9.36,6.45,27,27,0,0,1-2.89,1.13l-.77.24A.88.88,0,0,1,227.91,311.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.34,291.91c.43,0,10.38-.68,10.38-.68s-4.11,7.26-8.39,10h-8.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.17,333.87a3.23,3.23,0,0,1,.56-.43l1.68-1.16c1.45-1,3.54-2.5,6.05-4.43,5-3.83,11.66-9.55,18.78-16.09,3.56-3.27,7-6.35,9.94-9.31a77.76,77.76,0,0,0,7.33-8.32,45.19,45.19,0,0,0,4-6.3c.44-.77.71-1.4.92-1.82a3.54,3.54,0,0,1,.35-.63,4.2,4.2,0,0,1-.25.67c-.18.43-.43,1.08-.84,1.87a41.32,41.32,0,0,1-3.89,6.43,73.35,73.35,0,0,1-7.29,8.44c-2.95,3-6.37,6.09-9.93,9.35-7.12,6.54-13.79,12.24-18.9,16-2.55,1.89-4.68,3.33-6.16,4.3-.75.48-1.34.83-1.74,1.08A3.12,3.12,0,0,1,226.17,333.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.13,445s0-.09.12-.24.25-.39.41-.66c.37-.57.93-1.41,1.68-2.47,1.5-2.1,3.82-5.06,6.88-8.54,6.16-6.91,14.79-16.34,24.29-26.78L256,379.62l7.45-8,2-2.17.54-.55.2-.18s-.05.08-.16.21l-.5.59-2,2.24-7.33,8.15L231.9,406.63l-24.4,26.68c-3.09,3.44-5.45,6.35-7,8.41-.77,1-1.36,1.85-1.75,2.41l-.45.63A1.82,1.82,0,0,1,198.13,445Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.84,211c.86,1.29,20.18,3.44,24.91,8.16s52,40.8,52,40.8L328.06,305.3l-21.74-4.79Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.02 255.56 318.25 303.14 328.06 305.3 361.71 259.91 356.02 255.56",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.13,258.2a10.89,10.89,0,0,1-.39-1.58c-.11-.51-.24-1.14-.33-1.88s-.24-1.58-.29-2.52-.15-2-.15-3.07,0-2.28.09-3.52a48.78,48.78,0,0,1,1.25-8A48.06,48.06,0,0,1,298,230c.53-1.12,1-2.2,1.57-3.16s1.06-1.85,1.57-2.64,1-1.47,1.44-2.08a18.48,18.48,0,0,1,1.17-1.51,9.35,9.35,0,0,1,1.09-1.21,9.89,9.89,0,0,1-.93,1.33c-.31.42-.69.93-1.09,1.56s-.91,1.3-1.37,2.11-1,1.67-1.5,2.65-1,2-1.51,3.14a52,52,0,0,0-2.58,7.57,52.59,52.59,0,0,0-1.27,7.89c-.07,1.23-.16,2.4-.13,3.49s0,2.11.08,3,.14,1.77.21,2.51.16,1.37.24,1.88A8.69,8.69,0,0,1,295.13,258.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.25,295.48a97.7,97.7,0,0,1-4.17-9.23,99.1,99.1,0,0,1-3.7-9.42,99.65,99.65,0,0,1,4.18,9.22A95.69,95.69,0,0,1,310.25,295.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.7,262.54c-.08,0-.89-1.45-2.42-3.7a53.14,53.14,0,0,0-6.82-8.13,54.13,54.13,0,0,0-8.32-6.57c-2.3-1.46-3.81-2.22-3.77-2.3a5,5,0,0,1,1.1.45,32.25,32.25,0,0,1,2.86,1.54,46.19,46.19,0,0,1,8.5,6.51,46.89,46.89,0,0,1,6.76,8.3c.73,1.16,1.28,2.12,1.62,2.81A4.87,4.87,0,0,1,161.7,262.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.93 310.97 106.26 305.3 170.16 322.7 167.63 329.81 103.93 310.97",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.52,288.56h24.33v10l-31.13-.2S272.53,292.57,274.52,288.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M187.74,216.2c.88,7.8,1.84,15.85,5.7,22.69s11.41,12.23,19.18,11.08c5.18-.77,9.57-4.23,13.1-8.11s6.49-8.27,10.34-11.82a45.6,45.6,0,0,0,7.76,6.67,15.21,15.21,0,0,0,9.73,2.57c3.39-.41,5.26-1.76,6.33-5-3.62,1.12-5.61.95-9.22.26a25.21,25.21,0,0,1-10.91-5c-2.12-1.67-2.89-4.18-5.58-4-2.49.14-4.44,2.11-6.08,4a70,70,0,0,1-8.68,8.36c-3,2.37-5.9,4-9.72,3.89-6.29-.14-11.44-5.08-14.91-10.33a51.78,51.78,0,0,1-7-15.81"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M261.38,206.47a2.59,2.59,0,0,1,.11.56c0,.37.12.91.19,1.61.15,1.4.3,3.43.36,6a85.05,85.05,0,0,1-1.87,19.57l0,.16,0,.16-.15,0a21.18,21.18,0,0,1-10.77-.29,25.2,25.2,0,0,1-8-3.74,20.6,20.6,0,0,1-4.37-4,14,14,0,0,1-.94-1.3,3,3,0,0,1-.29-.49,25.56,25.56,0,0,0,5.8,5.52,25.85,25.85,0,0,0,7.9,3.58,21.14,21.14,0,0,0,10.52.25l-.19.19,0-.16a91.28,91.28,0,0,0,2-19.46c0-2.51-.11-4.54-.19-5.95,0-.65-.07-1.18-.1-1.61A2.08,2.08,0,0,1,261.38,206.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,226.2a2.54,2.54,0,0,1-.32.6,16.43,16.43,0,0,1-1.1,1.6,43.07,43.07,0,0,1-4.92,5.19c-1.11,1-2.36,2.11-3.71,3.25-.68.57-1.36,1.17-2.12,1.77a19.72,19.72,0,0,1-2.47,1.59,15.19,15.19,0,0,1-6,1.83,11.35,11.35,0,0,1-6.6-1.46,20.92,20.92,0,0,1-5.17-4.35,51.15,51.15,0,0,1-3.9-4.92,50.42,50.42,0,0,1-5.09-9.31,47.91,47.91,0,0,1-2.24-6.78c-.21-.82-.34-1.46-.42-1.9a3.4,3.4,0,0,1-.1-.67,2.94,2.94,0,0,1,.2.65c.12.43.28,1.06.51,1.87a56.71,56.71,0,0,0,2.39,6.69,51.79,51.79,0,0,0,5.15,9.17,50.54,50.54,0,0,0,3.88,4.85,20.54,20.54,0,0,0,5,4.25,10.92,10.92,0,0,0,6.31,1.4,15.06,15.06,0,0,0,5.84-1.74,18.58,18.58,0,0,0,2.43-1.54c.73-.56,1.43-1.17,2.11-1.73,1.36-1.13,2.62-2.19,3.74-3.19a48,48,0,0,0,5-5c.53-.64.92-1.17,1.18-1.53A4.18,4.18,0,0,1,231,226.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.46,341.1l7.71-11.24s5.3-18.42,4.58-21-3.06-12.18-2.51-12.3,6.32-2.26,9.45,5.44c1.95,4.8,2.59,11.12,2.8,15.2a3.49,3.49,0,0,0,4.19,3.26c5.33-1.1,14.2-2.77,16.31-2.26,3.06.73,5.8,4.63,6.06,5.94s-1.84,4.26-1.84,4.26,2.6,1.33,3.4,3.34c.11.27.2.54.28.8a4.84,4.84,0,0,1-1.07,4.68l-.82.9s3.25.89,3.65,2.75a11.11,11.11,0,0,1-.11,4.09l-3.05,3.15a5.15,5.15,0,0,1,1.58,3c.16,1.72-4.41,6-4.41,6l-19.61,7-7.78,2Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.27,328.42a69.54,69.54,0,0,1-6.8,1.47,67.57,67.57,0,0,1-6.82,1.3,8.5,8.5,0,0,1,1.93-.67c1.21-.34,2.9-.76,4.79-1.14s3.6-.66,4.86-.82A7.65,7.65,0,0,1,256.27,328.42Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.06,338.12a28.71,28.71,0,0,1-5.19,1.85,29,29,0,0,1-5.34,1.36,28.71,28.71,0,0,1,5.19-1.85A29,29,0,0,1,258.06,338.12Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.23,347.69a35.93,35.93,0,0,1-5.51,2.69A36.1,36.1,0,0,1,248,352.6a35.93,35.93,0,0,1,5.51-2.69A36.1,36.1,0,0,1,259.23,347.69Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.28,410.56l72.12-48.38-18.2-33-65.82,33.85,7.47-35.56-44.67-13.22L104,375.15h0c-1.72,27.08,20,48.94,46.18,41.83h0A47.7,47.7,0,0,0,164.28,410.56Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.85,382.17a3.05,3.05,0,0,1-.25-.91,16.72,16.72,0,0,1-.25-2.55,18,18,0,0,1,1.86-8.21,17.82,17.82,0,0,1,5.45-6.42,14.7,14.7,0,0,1,2.18-1.34,3.17,3.17,0,0,1,.88-.35c0,.09-1.17.66-2.84,2a18.63,18.63,0,0,0-7.16,14.35C142.67,380.84,143,382.16,142.85,382.17Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.06,305.3c.45-.62,51.36,30.4,51.36,30.4l16.32,74.35,23.49,8.62s7.33-82.74,1.75-95.62-62.15-59.22-62.15-59.22Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.54,330a13.43,13.43,0,0,1-4.41,4.16,13.61,13.61,0,0,1-5.62,2.3,56.85,56.85,0,0,0,5.34-2.74A53.47,53.47,0,0,0,390.54,330Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.83 305.46 270.82 376.82 352.18 371.32 349.72 318.2 337.87 302.25 266.83 305.46",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.34,378.41c.24,1.37,7.15,66,7.15,66L376.58,436l20.49-2.75-9.45-60.18-14.47-3.47Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.15,369.59l-124.81,8.82c.24,1.37,7.15,66,7.15,66l126.07-8.77Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.98 372.14 270.82 376.82 266.83 305.46 337.87 302.25 339.98 372.14",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.62 304.3 294.08 326.29 297.78 324.17 299.83 326.29 302.38 324.17 306.32 326.29 306.32 303.68 292.62 304.3",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.53 373.64 316.8 320.08 363.03 332.82 367.49 369.79 321.53 373.64",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,332.83a2.13,2.13,0,0,1-.29.38l-.89,1.05-3.4,3.88-11.81,13.25-.18.2-.19-.19L340,344.8l-16.47-17.4-4.95-5.32-1.33-1.46a2.84,2.84,0,0,1-.43-.54,4,4,0,0,1,.51.46l1.4,1.4,5.06,5.2,16.58,17.3,6.28,6.61h-.37l12-13.13,3.51-3.78.95-1A2,2,0,0,1,363,332.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.11,342.75c.13.07-3.17,6.39-7.36,14.12s-7.69,13.94-7.82,13.87,3.17-6.39,7.36-14.12S337,342.68,337.11,342.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.41,369.79c-.12.07-3.32-5.05-7.15-11.43s-6.84-11.63-6.71-11.71,3.32,5.05,7.15,11.44S366.54,369.72,366.41,369.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.36 371.55 343.34 337.44 372.78 345.56 375.62 369.1 346.36 371.55",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.36 371.55 343.34 337.44 372.78 345.56 375.62 369.1 346.36 371.55",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.78,345.56a5.66,5.66,0,0,1-.73.93c-.55.65-1.27,1.48-2.14,2.49l-7.5,8.46-.18.21-.19-.2-4-4.2c-4.11-4.31-7.81-8.24-10.47-11.1l-3.12-3.41a9.79,9.79,0,0,1-1.1-1.3,10.42,10.42,0,0,1,1.24,1.16l3.25,3.29c2.73,2.8,6.47,6.69,10.58,11l4,4.21H362l7.63-8.34,2.26-2.39A6.36,6.36,0,0,1,372.78,345.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.28,351.88c.12.07-1.94,4.11-4.61,9a97,97,0,0,1-5.06,8.79,96.75,96.75,0,0,1,4.6-9A95.54,95.54,0,0,1,356.28,351.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.94,369.1a71.32,71.32,0,0,1-4.64-7.23,68.16,68.16,0,0,1-4.19-7.51,147,147,0,0,1,8.83,14.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.12 344.12 365.12 346.86 369.42 347.36 369.65 345.27 365.12 344.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.94,330.21v4l8.12,1.34.45-3.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.25 393.58 317.85 373.64 301.68 374.73 303.41 394.99 318.25 393.58",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.88,
    y: 405.32,
    width: 27.27,
    height: 24.12,
    transform: "translate(-37.79 35.7) rotate(-5.42)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.22,428.1a3.57,3.57,0,0,1-.07-.46c0-.33-.09-.76-.15-1.3-.12-1.16-.3-2.81-.52-4.88-.43-4.22-1-10.18-1.76-17.35l.24.2-27.13,2.61c-.06.06.44-.53.23-.28h0v.18l0,.21,0,.4.08.82.15,1.62c.11,1.07.21,2.13.31,3.19.19,2.11.39,4.17.58,6.19.37,4,.73,7.85,1.05,11.38l-.25-.2,19.59-1.74,5.56-.47,1.49-.11a3.45,3.45,0,0,1,.53,0,2.9,2.9,0,0,1-.47.07l-1.44.17-5.5.58-19.71,2-.23,0,0-.23c-.35-3.54-.72-7.36-1.11-11.38q-.28-3-.59-6.19c-.1-1.06-.2-2.12-.3-3.2-.05-.53-.1-1.07-.16-1.61l-.07-.82,0-.4,0-.21v-.18h0c-.21.25.28-.35.24-.29l27.14-2.53.22,0,0,.22c.64,7.23,1.17,13.25,1.55,17.51.17,2.05.3,3.68.4,4.84,0,.53.07.95.09,1.27A2.55,2.55,0,0,1,373.22,428.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.82,409.84c0,.15-4.73.76-10.6,1.38a106.2,106.2,0,0,1-10.65.86c0-.14,4.73-.76,10.6-1.38S368.81,409.7,368.82,409.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.66,413.92a15.06,15.06,0,0,1-2.91.73c-1.82.36-4.35.78-7.16,1.11s-5.38.51-7.23.57a16.76,16.76,0,0,1-3,0,18.4,18.4,0,0,1,3-.34c1.84-.17,4.38-.4,7.18-.73s5.33-.69,7.16-1A20,20,0,0,1,368.66,413.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.81,422.84a15.62,15.62,0,0,1-2.92.73c-1.82.36-4.35.78-7.16,1.11s-5.37.51-7.23.57a15.53,15.53,0,0,1-3,0,18.36,18.36,0,0,1,3-.34c1.84-.16,4.39-.4,7.19-.73s5.33-.69,7.16-1A19.85,19.85,0,0,1,369.81,422.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.44,418.27a92.8,92.8,0,0,1-9.89,1.68,95.5,95.5,0,0,1-10,1.16,99.3,99.3,0,0,1,9.89-1.68A98.87,98.87,0,0,1,368.44,418.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.41,455.46s22.35-14.79,24.07-22.35,2.75-14.44,2.75-14.44l-23.88-9.89,2.37,8.6s-8.56,5.09-9.44,11.26c-.58,4.11-11.65,11.15-11.65,11.15h0A9.13,9.13,0,0,0,369,436.5l-9.3.66,6.29,14.17Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.14,435.19a3.56,3.56,0,0,1-1.05.43c-.7.23-1.74.46-3,.86a12.16,12.16,0,0,0-3.88,2.26,19.45,19.45,0,0,1-4.78,3,16.22,16.22,0,0,1-10.14.85,5.45,5.45,0,0,1-1.69-.63,1.24,1.24,0,0,1-.62-1.24.92.92,0,0,1,.5-.72c.2-.07.31,0,.31,0s-.11,0-.26.11a.85.85,0,0,0-.35.66,1,1,0,0,0,.58,1,5.62,5.62,0,0,0,1.62.51,16.64,16.64,0,0,0,9.85-1,19.51,19.51,0,0,0,4.68-2.94,12.09,12.09,0,0,1,4.06-2.22c1.28-.36,2.32-.53,3-.71A7.51,7.51,0,0,1,401.14,435.19Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.66,446.66c0,.08-1.15-.58-3.05-1.37a27.82,27.82,0,0,0-7.75-1.93c-.78-.08-1.55-.1-2.29-.12h-.14l-.08-.12a24,24,0,0,0-4.15-4.9c-1.21-1.09-2-1.65-2-1.71s.24.08.62.32a18.33,18.33,0,0,1,1.56,1.13,20.91,20.91,0,0,1,4.37,4.89l-.21-.12c.76,0,1.54,0,2.34.12a24.53,24.53,0,0,1,7.85,2.11,19.36,19.36,0,0,1,2.17,1.16A3,3,0,0,1,385.66,446.66Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.7,442.6c0,.14-1.51.71-3.27,1.71s-3.05,2.05-3.15,1.93a10.88,10.88,0,0,1,6.42-3.64Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.81,416c0,.16-1.56,0-3.34.45s-3,1.37-3.14,1.24a6.53,6.53,0,0,1,6.48-1.69Z",
    style: {
      fill: "#aa6550"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.77,407.47c2.94,3.5,7.91,1.81,10.06-.68s2.85-5.87,3.48-9.1c1.42-7.38,2.84-15.11.64-22.3a12.31,12.31,0,0,0-3.35-5.75,6.43,6.43,0,0,0-6.25-1.47c-2.5.9-3.87,3.55-4.8,6a52.69,52.69,0,0,0-3.18,23c.31,3.64,1.08,7.41,3.4,10.23",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.77,407.47c2.94,3.5,7.91,1.81,10.06-.68s2.85-5.87,3.48-9.1c1.42-7.38,2.84-15.11.64-22.3a12.31,12.31,0,0,0-3.35-5.75,6.43,6.43,0,0,0-6.25-1.47c-2.5.9-3.87,3.55-4.8,6a52.69,52.69,0,0,0-3.18,23c.31,3.64,1.08,7.41,3.4,10.23"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M89.24,425.5c4.08-2.59,9.09-3.33,13.9-3,2.59.2,5.31.72,7.22,2.48s2.53,5.1.69,6.92a6.66,6.66,0,0,1-4.28,1.5c-3.72.29-7.9,0-10.66,2.51-1.58,1.42-2.52,3.64-4.49,4.45a4.81,4.81,0,0,1-5.47-1.87,8.2,8.2,0,0,1-1.13-6A9.24,9.24,0,0,1,89.24,425.5Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.07,413.47c2.54-3.62,2.64-8.58,1-12.69s-4.82-7.43-8.36-10.07a40.08,40.08,0,0,0-14-6.64,14.33,14.33,0,0,0-6.06-.48A6.31,6.31,0,0,0,39,387.07c-1.15,2.78.47,5.89,2.15,8.39A102.66,102.66,0,0,0,51,407.94c2.91,3.13,6.2,6.18,10.31,7.35s8.22.61,10.09-2.33",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.62,463.78a8.31,8.31,0,0,0,.08-1.72c0-1.24,0-2.8,0-4.66a65.79,65.79,0,0,1,.44-6.89,52,52,0,0,1,1.75-8.23,29.4,29.4,0,0,1,3.44-7.61,15.33,15.33,0,0,1,4.79-4.76,14.47,14.47,0,0,1,4.23-1.75,9.81,9.81,0,0,0,1.67-.39,7.41,7.41,0,0,0-1.72.12,13.48,13.48,0,0,0-4.44,1.59,15.41,15.41,0,0,0-5.07,4.83,29.41,29.41,0,0,0-3.58,7.77,49.58,49.58,0,0,0-1.72,8.36,58.83,58.83,0,0,0-.29,6.95c0,2,.12,3.58.19,4.68A7.53,7.53,0,0,0,82.62,463.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.62,460.19a3.93,3.93,0,0,0,0-.79c0-.59-.12-1.34-.2-2.25-.18-1.95-.43-4.78-.64-8.28-.45-7-.71-16.68-.5-27.37s.92-20.36,1.73-27.32c.18-1.75.37-3.32.57-4.7s.34-2.57.5-3.53.24-1.65.33-2.24a3.57,3.57,0,0,0,.07-.79,2.88,2.88,0,0,0-.21.77c-.12.58-.27,1.31-.46,2.21s-.4,2.15-.62,3.53-.46,2.94-.68,4.69a255.53,255.53,0,0,0-1.93,27.37c-.21,10.71.12,20.42.7,27.42.27,3.5.6,6.33.87,8.27.13.91.25,1.65.33,2.24A3.81,3.81,0,0,0,82.62,460.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,441.55a14.49,14.49,0,0,0-.22-2.35c-.23-1.5-.63-3.66-1.29-6.3a85.69,85.69,0,0,0-2.9-9.09,82.55,82.55,0,0,0-4.86-10.63,58.74,58.74,0,0,0-13-16.73,31.69,31.69,0,0,0-2.91-2.25c-.44-.31-.83-.62-1.23-.86l-1.1-.63a16.54,16.54,0,0,0-2.09-1.09c-.1.16,3,1.62,7,5.21a61.86,61.86,0,0,1,12.69,16.68A88.91,88.91,0,0,1,76,424c1.32,3.32,2.28,6.39,3,9s1.19,4.74,1.5,6.22A14.55,14.55,0,0,0,81,441.55Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessengerPana);
export default __webpack_public_path__ + "static/media/Messenger-pana.6e063103a6edf643dbcccfc0e5949206.svg";
export { ForwardRef as ReactComponent };